import './Loading.css'

interface LoadingProps {
  size?: 'sm' | 'md' | 'lg'
  text?: string
  fullScreen?: boolean
}

export default function Loading({ size = 'md', text, fullScreen = false }: LoadingProps) {
  const spinner = (
    <div className={`loading-spinner loading-${size}`}>
      <div className="spinner"></div>
      {text && <div className="loading-text">{text}</div>}
    </div>
  )

  if (fullScreen) {
    return (
      <div className="loading-fullscreen">
        {spinner}
      </div>
    )
  }

  return spinner
}

